import {
  Component,
  ChangeDetectionStrategy,
  Directive,
  input,
  booleanAttribute,
  effect,
  contentChild,
  inject,
  computed,
  contentChildren,
} from '@angular/core';
import {Observable} from 'rxjs';
import {ValidationErrors} from '@angular/forms';
import {ErrorProvider, ErrorToken} from './declarations';
import {FIELD_CONTAINER_TOKEN} from '../../constants';

@Component({
  selector: 'ms-errors',
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ErrorsComponent {
  readonly forContainer = input(false, {transform: booleanAttribute});

  readonly errors = contentChildren(ErrorToken, {descendants: true});

  private readonly fieldContainer = inject(FIELD_CONTAINER_TOKEN, {optional: true});

  private readonly errorsMap = computed(() => {
    const map: MsApp.Dictionary<ErrorProvider> = {};

    for (const error of this.errors()) {
      map[error.customError.code()] = error;
    }

    return map;
  });

  constructor() {
    effect(() => {
      if (this.forContainer() && this.fieldContainer) {
        this.fieldContainer.setCustomErrors(this);
      }
    });
  }

  getMessage(errors: ValidationErrors | null): Observable<string> | null {
    if (errors === null) {
      return null;
    }

    const errorsMap = this.errorsMap();
    const errorCode = Object.keys(errors).find(code => code in errorsMap);

    if (!errorCode) {
      return null;
    }

    return errorsMap[errorCode].customError.message$;
  }
}

@Directive({
  selector: '[msErrorProvider]',
  standalone: true,
})
export class ErrorProviderDirective {
  readonly customErrors = contentChild(ErrorsComponent, {descendants: true});
}
